// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__P4L88","menuItem":"styles_menuItem__ivGDW","menuItem_pressed":"styles_menuItem_pressed__H6XiJ"};